@if (item) {
  <gridster-item
    #gridsterItemComponent
    [item]="item"
    [class.selected]="isSelected"
    [class.selected-layer]="isLayerSelected"
    [class.locked]="itemBlocked && editMode"
    (mousedown)="select()"
    [class.edit]="editMode"
    [class.no-padding]="!item.styles.padding"
    [class.no-background]="!item.styles.showBackground"
    [style.background]="item.styles.background ?? ''"
    [ngClass]="typeClass"
    (dblclick)="showSettings()"
  >
    @if (editMode) {
      <div class="gridster-item-drag"></div>
    }
    <div
      data-cy="dashboard-item"
      class="gridster-item-content"
      (mousedown)="$event.stopPropagation()"
      (touchstart)="$event.stopPropagation()"
    >
      <app-dashboard-item-content [item]="item"></app-dashboard-item-content>
    </div>
  </gridster-item>
}
